import type { IconSvgObject } from './types';

const Inequality01Icon: IconSvgObject = [
  ["path", { d: "M3 20H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 16H2.99995L17.3015 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Inequality01Icon;
